(function () {
  'use strict';

  function initFranquicias(root) {
    if (!root) return;

    var header = root.querySelector('.site-header');
    var toggle = root.querySelector('.mobile-toggle');
    var nav = root.querySelector('.site-header nav');

    if (header && toggle && nav && toggle.dataset.menuReady !== 'true') {
      toggle.dataset.menuReady = 'true';
      toggle.addEventListener('click', function () {
        var isOpen = header.classList.toggle('nav-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
        toggle.setAttribute('aria-label', isOpen ? 'Cerrar menú' : 'Abrir menú');
      });

      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          header.classList.remove('nav-open');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-label', 'Abrir menú');
        });
      });
    }

    var revealItems = root.querySelectorAll('[data-reveal]:not([data-reveal-ready])');
    revealItems.forEach(function (item) { item.dataset.revealReady = 'true'; });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries, instance) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          instance.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
      revealItems.forEach(function (item) { observer.observe(item); });
    } else {
      revealItems.forEach(function (item) { item.classList.add('is-visible'); });
    }

    root.querySelectorAll('a[href^="#"]:not([data-scroll-ready])').forEach(function (link) {
      link.dataset.scrollReady = 'true';
      link.addEventListener('click', function (event) {
        var selector = link.getAttribute('href');
        if (!selector || selector.length < 2) return;
        var target;
        try { target = document.querySelector(selector); }
        catch (error) { return; }
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-franquicias-section]').forEach(initFranquicias);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.closest('[data-franquicias-section]') || document.querySelector('[data-franquicias-section]');
    initFranquicias(root);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var selected = event.target.querySelector('[data-reveal]') || event.target.closest('[data-reveal]');
    if (selected) selected.classList.add('is-visible');
  });
})();
